<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconInstruct.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>仪器管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="仪器编号">
          <el-input v-model="filters.instrumentNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="仪器名称">
          <el-input v-model="filters.instrumentName" clearable></el-input>
        </el-form-item>
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="filters.cityCode" placeholder="选择区域" clearable>
            <el-option v-for="(item) in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="checkButton">
          <el-form-item label="使用日期">
            <el-select v-model="filters.useDate" clearable="" placeholder="选择日期">
              <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="添加时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div>
      </div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="instrumentCode" label="仪器编号"></el-table-column>
        <el-table-column prop="instrumentName" label="仪器名称"></el-table-column>
        <el-table-column prop="positionUseTime" label="仪器部位使用时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.positionUseTime" placement="top">
              <!-- el-tooltip显示内容换行插槽 -->
              <div slot="content">
                <div v-if="scope.row.positionUseTime">
                  <div v-for="(item,index) in scope.row.positionUseTime.split('，')" :key="index">
                    <span>{{item}}</span>
                  </div>
                </div>
              </div>
              <div v-if="scope.row.positionUseTime" class="showOverTooltip">
                <div v-for="(item,index) in scope.row.positionUseTime.split('，')" :key="index">
                  <span>{{item}}</span>
                </div>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="useMinute" label="单次使用时间"></el-table-column> -->
        <el-table-column prop="useDate" label="使用时间">
          <template slot-scope="scope">
            <span v-for="(item,index) in  scope.row.useDate" :key="index">
              <span v-if="item==1">周一 </span>
              <span v-if="item==2">周二 </span>
              <span v-if="item==3">周三 </span>
              <span v-if="item==4">周四 </span>
              <span v-if="item==5">周五 </span>
              <span v-if="item==6">周六 </span>
              <span v-if="item==7">周日 </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间"></el-table-column>
        <el-table-column prop="userName" label="添加人"></el-table-column>
        <el-table-column prop="cityName" label="区域"></el-table-column>
        <!-- <el-table-column prop="isDisable" label="是否禁用">
          <template slot-scope="scope">
            <div v-if="scope.row.isDisable=='1'||scope.row.isDisable==null">
              <el-switch :value="scope.row.isDisable=true" active-color="#13ce66" inactive-color="#eee" @change="onChange(scope.$index, scope.row)">
              </el-switch>
            </div>
            <div v-if="scope.row.isDisable=='0'">
              <el-switch :value="scope.row.isDisable=false" active-color="#13ce66" inactive-color="#eee" @change="onChange(scope.$index, scope.row)">
              </el-switch>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="medium" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增编辑仪器弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="区域">
          <el-select @change="handChange" :disabled="disabled" v-model="formData.cityCode" placeholder="选择区域" style="width:95%;" multiple>
            <el-option v-for="(item,index) in citys" :key="index" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-for="(domain, index) in formData.areaList" :key="index">
          <div class="instrucPosition">
            <el-form-item label="院区/楼层">
              <el-select @input="testSX" @change="areaChange($event,index)" v-model="domain.areaCode" placeholder="请选择院区" style="width:45%;float:left;margin-left:2.5%;">
                <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
              <el-select @input="testSX" :disabled='domain.disabled' v-model="domain.floorCode" placeholder="请选择楼层" style="width:43%;margin-right:5.1%;">
                <el-option v-for="(item) in domain.floorOptions" :key="item.floorCode" :label="item.floorName" :value="item.floorCode">
                </el-option>
              </el-select>
              <el-button size="mini" type="danger" @click.prevent="removeArea(domain)" v-show="index > 0">
                <i class="el-icon-delete"></i>
              </el-button>
            </el-form-item>
          </div>
        </div>
        <el-form-item style="text-align: right;margin-right:5%;">
          <el-button @click="addArea" type="primary" size="mini">新增院区</el-button>
        </el-form-item>

        <el-form-item label="仪器名称">
          <el-input v-model="formData.instrumentName" style="width:95%;">
          </el-input>
        </el-form-item>
        <div>
          <draggable v-model="formData.instrumentPosition" group="people" @input="testSX">
            <div v-for="(domain, index) in formData.instrumentPosition" :key="index">
              <div class="instrucPosition">
                <el-form-item :label="'部位' + (index+1)">
                  <el-select v-model="domain.positionId" @focus="positionFocus" :remote-method="positionRemoteMethod" filterable remote clearable placeholder="请输入搜索部位" style="width:45%;float:left;margin-left:2.5%;" @change="positionChange($event,index)" @input="testSX">
                    <el-option v-for="(item,index) in positionOptions" :key="index" :label="item.positionName" :value="item.positionId" :disabled="item.disabled">
                    </el-option>
                  </el-select>
                  <el-input v-model="domain.useMinute" style="width:43%;margin-right:5.1%;" placeholder="请输入仪器部位使用时间(分钟)" @input="testSX">
                  </el-input>
                  <el-button size="mini" type="danger" @click.prevent="removeDomain(domain)" v-show="index > 0">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </el-form-item>
              </div>
            </div>
          </draggable>
        </div>
        <el-form-item style="text-align: right;margin-right:5%;">
          <el-button @click="addDomain" type="primary" size="mini">新增部位</el-button>
        </el-form-item>
        <el-form-item label="使用日期">
          <el-select v-model="formData.useDate" multiple placeholder="选择日期" style="width:95%;">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="breaktime">
          <el-form-item label="仪器休息时间" v-if="flag">
            <el-date-picker @input="testSX" v-model="formData.breaktime" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "member",
  components: {
    draggable,
  },
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        instrumentPosition: [{
          positionId: '',
          useMinute: '',
          positionName: ''
        }],
        areaList: [
          {
            areaCode: '',
            areaName: '',
            floorCode: '',
            floorName: '',
            floorOptions: [{
              floorName: '2楼',
              floorCode: '2'
            }, {
              floorName: '3楼',
              floorCode: '3'
            },
            {
              floorName: '12楼',
              floorCode: '12'
            },
            ],
          }
        ],
      },
      areaOptions: [],

      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      instrumentId: '',

      options: [{
        value: 1,
        label: '周一'
      }, {
        value: 2,
        label: '周二'
      }, {
        value: 3,
        label: '周三'
      }, {
        value: 4,
        label: '周四'
      }, {
        value: 5,
        label: '周五'
      }, {
        value: 6,
        label: '周六'
      }, {
        value: 7,
        label: '周日'
      }],
      positionOptions: [],
      flag: false,
      citys: [
        {
          name: '上海',
          cityCode: '1'
        },
        {
          name: '南通',
          cityCode: '2'
        },
      ],
      cityCode: Lockr.get('cityCode'),
      disabled: false,
    }
  },
  methods: {
    // 禁用操作
    onChange(index, row) {
      console.log(row)
      let data = {
        instrumentId: row.id,
        // isDisable: ""
      }
      if (row.isDisable == null) {
        row.isDisable = '1'
      }
      if (row.isDisable == '1') {
        data.isDisable = '0'
      } else if (row.isDisable == '0') {
        data.isDisable = '1'
      }
      api.request("/instrument/updateInstrumentStatus", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")

          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      }, (err) => { })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    testSX() {
      // console.log('强制刷新')
      this.$forceUpdate()
    },
    positionChange(val, index) {
      this.positionOptions.forEach(ele => {
        if (ele.positionId == val) {
          // console.log(ele.positionName)
          this.formData.instrumentPosition[index].positionName = ele.positionName
        }
      });
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增仪器
    add() {
      this.dialogFormVisible = true
      this.flag = false
      // 新增置空
      this.formData = {
        instrumentPosition: [{
          positionId: '',
          useMinute: '',
          positionName: ''
        }],
        areaList: [
          {
            areaCode: '',
            areaName: '',
            floorCode: '',
            floorName: '',
          }
        ],
        cityCode: this.cityCode
      }
      this.instrumentId = ''
    },
    // 删除仪器
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        console.log(item)
        id.push(item.id)
      })
      console.log(id)
      this.$confirm('确定要删除选中的数据吗？', '删除仪器', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/instrument/deleteInstrument", {
            instrumentIds: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    // 确定新增
    doAddgoods() {
      let empId = Lockr.get("empId")
      if (!this.instrumentId) {
        // 新增仪器接口
        let data = {
          instrumentName: this.formData.instrumentName,
          // useMinute: this.formData.useMinute,
          useDate: this.formData.useDate.toString(),
          userId: empId,
          instrumentPosition: this.formData.instrumentPosition,
          cityCode: this.formData.cityCode.toString(),
          areaName: '',
          areaCode: this.formData.areaList[0].areaCode,
          floorCode: this.formData.areaList[0].floorCode,
          floorName: '',
          isPublic: '',//是否为公用仪器是否公用仪器  1：是  2：否    null:历史数据
        }
        let newArr = this.formData.areaList.map(function (item) {
          return item.areaCode + '|' + item.floorCode
        })
        let isCludesArr = this.formData.areaList.map(function (item) {
          return item.areaCode
        })
        if (isCludesArr.includes('bsl') == true && isCludesArr.includes('fls') == true) {
          data.isPublic = 1
        } else {
          data.isPublic = 2
        }
        this.areaOptions.forEach(ele => {
          if (this.formData.areaList[0].areaCode == ele.areaCode) {
            data.areaName = ele.areaName
          }
        });
        this.formData.areaList[0].floorOptions.forEach(ele => {
          console.log(this.formData.areaList[0].floorCode);
          if (this.formData.areaList[0].floorCode == ele.floorCode) {
            // console.log('000000000');
            data.floorName = ele.floorName
            // console.log(data.floorName);
          }
        });
        data.publicStr = newArr.toString()
        // console.log(data)
        api.requestQuiet("/instrument/insertInstrumentManagement", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "新增成功")
            this.query(this.filters.pagination.page)
          } else {
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      } else {
        // 修改仪器接口
        let data = {
          instrumentId: this.instrumentId,
          instrumentName: this.formData.instrumentName,
          // useMinute: turnUseData,
          instrumentPosition: this.formData.instrumentPosition,
          useDate: this.formData.useDate.toString(),
          userId: empId,
          areaCode: this.formData.areaList[0].areaCode,
          floorCode: this.formData.areaList[0].floorCode,
          areaName: '',
          floorName: '',
          repairStartime: '',
          repairEndtime: '',
          isPublic: '',//是否为公用仪器是否公用仪器  1：是  2：否    null:历史数据
          cityCode: this.formData.cityCode.toString(),
        }
        if (this.formData.breaktime != undefined) {
          data.repairStartime = _g.transformTime(this.formData.breaktime[0])
          data.repairEndtime = _g.transformTime(this.formData.breaktime[1])
        } else {
          data.repairStartime = null
          data.repairEndtime = null
        }
        let newArr = this.formData.areaList.map(function (item) {
          return item.areaCode + '|' + item.floorCode
        })
        let isCludesArr = this.formData.areaList.map(function (item) {
          return item.areaCode
        })
        // 是否公用仪器  1：是  2：否    null:历史数据isPublic
        if (isCludesArr.includes('bsl') == true && isCludesArr.includes('fls') == true && isCludesArr.includes('ntbsl') == true) {
          data.isPublic = 1
        } else {
          data.isPublic = 2
        }
        this.areaOptions.forEach(ele => {
          if (this.formData.areaList[0].areaCode == ele.areaCode) {
            data.areaName = ele.areaName
          }
        });
        this.formData.areaList[0].floorOptions.forEach(ele => {
          if (this.formData.areaList[0].floorCode == ele.floorCode) {
            data.floorName = ele.floorName
          }
        });
        data.publicStr = newArr.toString()
        api.requestQuiet("/instrument/updateInstrumentManagement", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      }

    },
    handleEdit(index, row) {
      this.dialogFormVisible = true
      this.flag = false
      this.instrumentId = row.id
      if (row.id) {
        this.flag = true
      } else if (!row.id) {
        this.flag = false
      }
      api.request("/instrument/findInstrumentById", {
        instrumentId: this.instrumentId
      }, (res) => {
        this.formData = res.data.InstrumentManagement
        if (res.data.InstrumentPosition.length == 0) {
          this.formData.instrumentPosition = [{
            positionId: '',
            useMinute: '',
            positionName: ''
          }]
        } else {
          this.formData.instrumentPosition = res.data.InstrumentPosition
        }
        this.positionRemoteMethod()
        let turnNum = function (nums) {
          return nums.map(Number);
        }
        let turnUserDate = turnNum(row.useDate.split(','))
        this.formData.useDate = turnUserDate
        if (res.data.InstrumentManagement.repairStartime != null) {
          this.formData.breaktime = [new Date(res.data.InstrumentManagement.repairStartime), new Date(res.data.InstrumentManagement.repairEndtime)]
        }
        if (this.formData.publicStr == null) {
          this.formData.areaList = [
            {
              areaCode: this.formData.areaCode,
              areaName: '',
              floorCode: this.formData.floorCode,
              floorName: '',
            }
          ]
          if (this.formData.areaCode == 'fls') {
            this.formData.areaList[0].floorOptions = [{
              floorName: '1楼',
              floorCode: '1'
            },]
          } else if (this.formData.areaCode == 'bsl') {
            this.formData.areaList[0].floorOptions = [{
              floorName: '2楼',
              floorCode: '2'
            }, {
              floorName: '3楼',
              floorCode: '3'
            }, {
              floorName: '12楼',
              floorCode: '12'
            },]
          } else if (this.formData.areaCode == 'ntbsl') {
            this.formData.areaList[0].floorOptions = [{
              floorName: '1楼',
              floorCode: '1'
            },]
          }

        } else {
          let arr = this.formData.publicStr.split(',')
          var newArr = []
          arr.map(function (item) {
            var array = item.split('|')
            let keys = ['areaCode', 'floorCode']
            let object = Object.fromEntries(array.map((v, i) => [keys[i], v]));
            newArr.push(object)
          })
          this.formData.areaList = newArr
          this.formData.areaList.forEach(item => {
            if (item.areaCode == 'fls') {
              item.disabled = true
              item.floorOptions = [{
                floorName: '1楼',
                floorCode: '1'
              },]
            } else if (item.areaCode == 'bsl') {
              item.disabled = false
              item.floorOptions = [{
                floorName: '2楼',
                floorCode: '2'
              }, {
                floorName: '3楼',
                floorCode: '3'
              }, {
                floorName: '12楼',
                floorCode: '12'
              },]
            } else if (item.areaCode == 'ntbsl') {
              item.disabled = true
              item.floorOptions = [{
                floorName: '1楼',
                floorCode: '1'
              },]
            }
          });
        }
        if (this.formData.cityCode == '1') {
          this.areaOptions = [{
            areaName: '伯思立',
            areaCode: 'bsl'
          }, {
            areaName: '翡立思',
            areaCode: 'fls'
          }]
        } else if (this.formData.cityCode == '2') {
          this.areaOptions = [{
            areaName: '南通伯思立',
            areaCode: 'ntbsl'
          }]
        } else {
          this.areaOptions = [{
            areaName: '伯思立',
            areaCode: 'bsl'
          }, {
            areaName: '翡立思',
            areaCode: 'fls'
          }, {
            areaName: '南通伯思立',
            areaCode: 'ntbsl'
          }]
        }
      }, (err) => { })
    },
    areaChange(val, index) {
      if (val == 'fls') {
        this.formData.areaList[index].floorCode = '1'
        this.formData.areaList[index].floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        },]
        this.formData.areaList[index].disabled = true
      } else if (val == 'bsl') {
        this.formData.areaList[index].floorCode = ''
        this.formData.areaList[index].disabled = false
        this.formData.areaList[index].floorOptions = [{
          floorName: '2楼',
          floorCode: '2'
        }, {
          floorName: '3楼',
          floorCode: '3'
        },
        {
          floorName: '12楼',
          floorCode: '12'
        },
        ]
      } else if (val == 'ntbsl') {
        this.formData.areaList[index].floorCode = '1'
        this.formData.areaList[index].floorOptions = [{
          floorName: '1楼',
          floorCode: '1'
        },]
        this.formData.areaList[index].disabled = true
      }
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.cityCode)
      var querys = {
        instrumentNo: this.filters.instrumentNo,
        instrumentName: this.filters.instrumentName,
        useDate: this.filters.useDate,
        useMinute: this.filters.useMinute,
        page: page,
        size: this.filters.pagination.limit,
        cityCode: this.filters.cityCode == undefined || !this.filters.cityCode ? '' : this.filters.cityCode,
        startTime: '',
        endTime: '',
        // areaType: this.filters.areaCode
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.requestQuiet('/instrument/findInstrumentList', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.tableData = this.tableData;
        this.filters.pagination.total = parseInt(res.data.total)

      }, (err) => { })
    },
    // 搜索查询全部部位
    positionRemoteMethod(val) {
      let data = {
        positionName: val
      }
      api.request('/position/findPositions', data, (res) => {
        // console.log(res)
        this.positionOptions = res.data
        this.positionOptions.map((x, i) => {
          this.formData.instrumentPosition.map((s) => {
            if (x.positionId === s.positionId) {
              x.disabled = true
            }
          })
        })
      }, (err) => { })
    },
    positionFocus() {
      let data = {
        positionName: ''
      }
      api.request('/position/findPositions', data, (res) => {
        // console.log(res)
        this.positionOptions = res.data
        this.positionOptions.map((x, i) => {
          this.formData.instrumentPosition.map((s) => {
            if (x.positionId === s.positionId) {
              x.disabled = true
            }
          })
        })
        console.log(this.positionOptions)
      }, (err) => { })


    },
    removeDomain(item) {
      var index = this.formData.instrumentPosition.indexOf(item)
      if (index !== -1) {
        this.formData.instrumentPosition.splice(index, 1)
      }
      this.$forceUpdate()
    },
    addDomain() {
      this.formData.instrumentPosition.push({
        positionId: '',
        positionName: '',
        useMinute: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
    addArea() {
      this.formData.areaList.push({
        areaCode: '',
        areaName: '',
        floorCode: '',
        floorName: '',
        key: Date.now()
      });
      this.$forceUpdate()
    },
    removeArea(item) {
      var index = this.formData.areaList.indexOf(item)
      if (index !== -1) {
        this.formData.areaList.splice(index, 1)
      }
      this.$forceUpdate()
    },
    handChange() {
      this.formData.areaList.forEach(ele => {
        ele.areaCode = ''
        ele.floorCode = ''
      });
      if (this.formData.cityCode == '1') {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }]
      } else if (this.formData.cityCode == '2') {
        this.areaOptions = [{
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      } else {
        this.areaOptions = [{
          areaName: '伯思立',
          areaCode: 'bsl'
        }, {
          areaName: '翡立思',
          areaCode: 'fls'
        }, {
          areaName: '南通伯思立',
          areaCode: 'ntbsl'
        }]
      }
    }
  },
  mounted() {
    /*this.init();*/
    if (this.cityCode && this.cityCode != 'null') {
      this.filters.cityCode = Lockr.get("cityCode")
      this.disabled = true
    } else {
      this.disabled = false
    }
    if (this.cityCode == '1') {
      this.areaOptions = [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }]
    } else if (this.cityCode == '2') {
      this.areaOptions = [{
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }]
    } else {
      this.areaOptions = [{
        areaName: '伯思立',
        areaCode: 'bsl'
      }, {
        areaName: '翡立思',
        areaCode: 'fls'
      }, {
        areaName: '南通伯思立',
        areaCode: 'ntbsl'
      }]
    }
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  height: 34px;
  background: #ffffff;
  border-radius: 3px;
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}
.breaktime >>> .el-input__inner {
  width: 95%;
}
.breaktime >>> .el-date-editor .el-range__icon {
  line-height: 26px !important;
}
.breaktime >>> .el-date-editor .el-range__close-icon {
  line-height: 26px !important;
}
.breaktime >>> .el-date-editor .el-range-separator {
  line-height: 26px !important;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.minute {
  margin-left: 5px;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.instrucPosition >>> .el-button i {
  margin: 0 !important;
}

.showOverTooltip {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  /*这里是3行*/
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
</style>